import address from './address.json';
import contact from './contact.json';

export default {
  'personal-information': {
    ...address,
    ...contact,
  },
};
